module.exports = __webpack_public_path__ + "img/feature-play.cb1a6d58.png";